module.exports = __webpack_public_path__ + "img/team-business-bg.178622b1.svg";